import styled from 'styled-components';
import { StickVideoProps, Title, Video } from '@components';
import { breakpoints } from '@config';

export interface InnerProps {
  position?: StickVideoProps['position'];
}

export interface ShadowProps {
  shadow: string;
}

export interface ContentWrapperProps {
  position?: StickVideoProps['position'];
}

export const Wrapper = styled.section`
  margin-bottom: 112px;

  @media (min-width: ${breakpoints.pc}) {
    margin-bottom: 120px;
  }
`;

export const Inner = styled.div<InnerProps>`
  @media (min-width: ${breakpoints.pc}) {
    position: relative;
    display: flex;
    flex-direction: ${ ({ position }) => (position === 'right') && 'row-reverse' };
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  height: 500px;
  overflow: hidden;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: 40px;
  
  @media (min-width: ${breakpoints.pc}) {
    position: sticky;
    top: 0;
    flex: 0 1 70%;
    height: 100vh;
    box-sizing: border-box;
    padding: 64px 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
`;

export const StyledVideo = styled(Video)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;

  @media (min-width: ${breakpoints.pc}) {
    border-radius: 48px;
    transform: translateZ(0);
  }
`;

export const Shadow = styled.div<ShadowProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: -50px;
  right: -50px;
  background: ${({ shadow }) => shadow};
  z-index: 10;

  @media (min-width: ${breakpoints.pc}) {
    top: 64px;
    bottom: 64px;
    left: 0;
    right: 0;
    border-radius: 48px;
  }
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  @media (min-width: ${breakpoints.pc}) {
    position: relative;
    display: flex;
    align-items: flex-end;
    flex: 1 1 30%;
    height: 100vh;
    margin-left: ${({ position }) => (position === 'left') && '-10%'};
    margin-right: ${({ position }) => (position === 'right') && '-10%'};
    z-index: 10;
  }
`;

export const Content = styled.div`
  @media (min-width: ${breakpoints.pc}) {
    padding-bottom: 50px;
  }
`;

export const Icons = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 28px;

  @media (min-width: ${breakpoints.pc}) {
    margin-bottom: 32px;
  }
`;

export const StyledTitle = styled(Title)`
  margin-bottom: 16px;
  
  @media (min-width: ${breakpoints.pc}) {
    margin-bottom: 24px;
  }
`;
